import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.pad-end.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import axios from 'axios';
import { MessageBox } from 'element-ui';
import store from '@/store';
import { getRefreshToken, getToken } from '@/utils/auth';
var refreshClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
});
var refreshTokenPromise = null;
var reloginPromptActive = false;
function parseTokenPayload(token) {
  if (!token) {
    return null;
  }
  try {
    var payload = token.split('.')[1];
    if (!payload) {
      return null;
    }
    payload = payload.replace(/-/g, '+').replace(/_/g, '/');
    var paddedPayload = payload.padEnd(payload.length + (4 - payload.length % 4) % 4, '=');
    return JSON.parse(window.atob(paddedPayload));
  } catch (error) {
    console.warn('[auth] 解析 access token 失败:', error);
    return null;
  }
}
export function isAccessTokenExpired() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getToken();
  var bufferSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var payload = parseTokenPayload(token);
  if (!(payload !== null && payload !== void 0 && payload.exp)) {
    return false;
  }
  var now = Math.floor(Date.now() / 1000);
  return payload.exp <= now + bufferSeconds;
}
export function refreshAccessToken() {
  return _refreshAccessToken.apply(this, arguments);
}
function _refreshAccessToken() {
  _refreshAccessToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var _store$state;
    var currentRefreshToken;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (!refreshTokenPromise) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, refreshTokenPromise);
        case 1:
          currentRefreshToken = (store === null || store === void 0 || (_store$state = store.state) === null || _store$state === void 0 || (_store$state = _store$state.user) === null || _store$state === void 0 ? void 0 : _store$state.refreshToken) || getRefreshToken();
          if (currentRefreshToken) {
            _context2.n = 2;
            break;
          }
          throw new Error('refresh token missing');
        case 2:
          refreshTokenPromise = refreshClient.post('/api/v5/auth/refresh', {
            refreshToken: currentRefreshToken
          }).then(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
              var res, _res$data, accessToken, refreshToken;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    res = response.data;
                    if (!(!res || res.code < 200 || res.code >= 300 || !res.data)) {
                      _context.n = 1;
                      break;
                    }
                    throw new Error((res === null || res === void 0 ? void 0 : res.message) || 'refresh failed');
                  case 1:
                    _res$data = res.data, accessToken = _res$data.accessToken, refreshToken = _res$data.refreshToken;
                    _context.n = 2;
                    return store.dispatch('user/updateTokens', {
                      accessToken: accessToken,
                      refreshToken: refreshToken
                    });
                  case 2:
                    return _context.a(2, {
                      accessToken: accessToken,
                      refreshToken: refreshToken
                    });
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).finally(function () {
            refreshTokenPromise = null;
          });
          return _context2.a(2, refreshTokenPromise);
      }
    }, _callee2);
  }));
  return _refreshAccessToken.apply(this, arguments);
}
export function handleAuthExpired() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '你的认证信息已过期，请重新登录。';
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '登录状态失效';
  if (reloginPromptActive) {
    return Promise.reject(new Error(message));
  }
  reloginPromptActive = true;
  MessageBox.confirm(message, title, {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(function () {
    store.dispatch('user/resetToken').then(function () {
      location.reload();
    });
  }).finally(function () {
    reloginPromptActive = false;
  });
  return Promise.reject(new Error(message));
}